module.exports = __webpack_public_path__ + "img/prize-sty-light.d812770f.png";